// src/helpers/iaFlags.js
//
// Feature flags del bloque de IA. En modo DEMO solo se expone el
// "mini asistente" (botón 🤖 IA dentro de cada card del Panel Inteligente),
// el resto de funciones quedan en backend pero ocultas del UI para una
// presentación conservadora.
//
// Para revelar todo lo demás: cambia DEMO_MODE a false.
// O para ajuste fino, cambia los flags individuales.

const DEMO_MODE = true;

export const IA_FLAGS = Object.freeze({
  miniAsistente: true,
  menuConfigEmpresa: true,
  menuCalidadDatos: false,                  // Mantener oculto (es admin tools)
  menuPlanDia: true,                        // Inocuo (ya hay sidebar)
  dashboardBannerReporteEjecutivo: true,    // ← Lo que pediste
  dashboardBannerPlanDia: true,             // Tile útil en dashboard
  panelBadgeProbabilidad: true,             // Badge informativo
  panelKpiValorEsperado: true,              // KPI útil
  panelOrdenValorEsperado: true,            // Opción de orden útil
});

export const isIaDemoMode = () => DEMO_MODE;
